import  { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import TaskForm from "./TaskForm";

function EditTask() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("jwtToken");
  const { userInfo } = useAuth();
  const role = userInfo?.role || "";

  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTask = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tasks/get/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`            },
          }
        );
        setInitialData(res.data.data);
      } catch (err) {
        console.error("Fout bij ophalen taak", err);
        alert("Taak niet gevonden.");
        navigate("/tasks");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTask();
  }, [id, token, navigate]);

  const handleUpdate = async (data) => {
    const {
      task_id,
      created_at,
      updated_at,
      user_names,
      users,
      ...rest
    } = data;

    const cleanData = {
      ...rest,
      user_ids: Array.isArray(rest.user_ids)
        ? rest.user_ids
        : typeof rest.user_ids === "string"
        ? [rest.user_ids]
        : [],
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/update/${id}`,
        cleanData,
        {
          headers: {
            Authorization: `Bearer ${token}`          },
        }
      );
      alert("Taak bijgewerkt!");
      navigate("/tasks");
    } catch (err) {
      console.error("Fout bij bijwerken taak", err);
      alert("Bijwerken mislukt.");
    }
  };

  if (!["super_admin", "locatie_admin"].includes(role)) {
    return <p>Je hebt geen rechten om deze taak te bewerken.</p>;
  }

  if (isLoading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border" role="status"></div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2>Taak Bewerken</h2>
      <TaskForm
        initialData={initialData}
        onSubmit={handleUpdate}
        isEditing={true}
        submitLabel="Bijwerken"
      />
    </div>
  );
}

export default EditTask;